<div style="display: flex; flex-direction: column;">
  <div style="display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 27px;">

    <span
      (click)="toggleChart('firstDeltaActive')"
      statistic
      [statisticElementName]="'toggle chart Delta=0.1'"
      [class.active]="firstDeltaActive"
      class="delta delta1"
    >
      Delta=0.1
    </span>

    <span
      (click)="toggleChart('secondDeltaActive')"
      statistic
      [statisticElementName]="'toggle chart Delta=0.25'"
      [class.active]="secondDeltaActive"
      class="delta delta2"
      style="margin-left: 20px;"
    >
      Delta=0.25
    </span>
  </div>

  <div class="ignore-darkreader" id='{{chartId}}' style="flex: 1;"></div>
</div>
